<header-title [model]="headerTitle"></header-title>
<section role="main" class="content-body tab-menu-opened">
    <div class="row">
        <div class="col">
            <section class="card">
                <header class="card-header">
                    <h2 class="card-title">Create New Audit</h2>
                </header>
                <div class="card-body py-5">
                    <form (submit)="addCompanyAudit()" [formGroup]="addCompanyAuditFormGroup">
                        <fieldset>
                            <div class="panel-body">
                                <error-message [errors]="errors"></error-message>
                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <label class="control-label">Title</label>
                                        <input type="text" class="form-control" formControlName="title" />
                                    </div>
                                    <div class="col-md-4">
                                        <label class="control-label">Audit</label>
                                        <select name="auditTypeId" class="form-control" formControlName="auditId">
                                            <option [value]="''">--Select Audit--</option>
                                            <option *ngFor="let audit of audits" value="{{audit.id}}">{{audit.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <label class="control-label">Start Date</label>
                                        <input id="startDate"
                                               name="startDate"
                                               class="form-control"
                                               formControlName="startDate"
                                               type="text"
                                               placeholder="DD/MM/YYYY"
                                               bsDatepicker
                                               [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                    </div>
                                    <div class="col-md-4">
                                        <label class="control-label">End Date</label>
                                        <input id="endDate"
                                               name="endDate"
                                               class="form-control"
                                               formControlName="endDate"
                                               type="text"
                                               placeholder="DD/MM/YYYY"
                                               bsDatepicker
                                               [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                    </div>
                                </div>
                            </div>
                            <footer class="panel-footer mt-3">
                                <div class="row">
                                    <div class="col-sm-9 col-sm-offset-3">
                                        <button class="btn btn-success" type="submit">Create</button>
                                        <button class="btn btn-info ml-1" type="button" (click)="onBack()">Back</button>
                                    </div>
                                </div>
                            </footer>
                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
    </div>
</section>
